import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
	selector: '[qeDisableAutocomplete]',
})
export class DisableAutocompleteDirective implements AfterViewInit, OnDestroy {
	private readonly ngUnsubscribe$: Subject<boolean> = new Subject();

	constructor(
		private readonly el: ElementRef<HTMLInputElement>,
		private readonly renderer: Renderer2,
	) { }

	ngAfterViewInit(): void {
		const { nativeElement: inputEl } = this.el;
		this.renderer.setAttribute(inputEl, 'autocomplete', 'new-password');
		fromEvent(inputEl, 'focus')
			.pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe(() => {
				this.renderer.setAttribute(inputEl, 'type', 'search');
			});

		fromEvent(inputEl, 'blur')
			.pipe(takeUntil(this.ngUnsubscribe$))
			.subscribe(e => {
				this.renderer.setAttribute(inputEl, 'type', 'text');
			});
	}

	ngOnDestroy(): void {
		this.ngUnsubscribe$.next(true);
		this.ngUnsubscribe$.unsubscribe();
	}

}
